export default function Capitalize(str) {
  if (str !== undefined) {
    //return str.charAt(0).toUpperCase() + str.slice(1);
    return str.replace(/\w\S*/g, function(txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  } else {
    return "";
  }
}



// WEBPACK FOOTER //
// ./src/utils/textToCapitalize.js